import React, { useEffect, useState } from 'react'
import moment from 'moment';
import { Spinner } from 'reactstrap';

//Logo
import LogoSistema from "../../../assets/img/img/logo.png";

//Components
import Loading from "../../../components/Loading";

//Services
import { showMessage } from "../../../services/message";
import { api_GET } from "../../../services/api_service";

export default function RelatorioIF() {
    const [dadosRelatorio, setDadosRelatorio] = useState([]);
    const [loading, setLoading] = useState(false);

    const queryString = require('query-string');

    async function loadDadosRelatorio() {
        try {
            const query_string = queryString.parse(window.location.search);

            const mes = query_string.mes;
            const ano = query_string.ano;
            const hash_usuario = query_string.hash_usuario;
            const hash_contratada = query_string.hash_contratada;
            const tenantId = query_string.tenantId;

            setLoading(true);
            const { data } = await api_GET(`RelatorioIF?mes=${mes}&ano=${ano}&hash_contratada=${hash_contratada}&hash_usuario=${hash_usuario}`, `${tenantId}`);
            setDadosRelatorio(data);
        } catch (error) {
            showMessage("Aviso", error.message, 'error', null);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        loadDadosRelatorio();
    }, []);

    return (
        <div className="bg-white" style={{ height: '100vh' }}>
            {loading && <Loading />}
            <div className="container-fluid " style={{ background: "#FFF", height: "100%" }}>
                <div className="d-flex justify-content-between align-items-center p-3">
                    <img src={LogoSistema} alt="logo do sistema" height={50} />
                    <button
                        className="btn btn-info"
                        id="btnImprimir"
                        onClick={() => {
                            if (!loading) window.print();
                        }}
                    >
                        {loading && <Spinner size="sm" color="primary" />} &nbsp; Imprimir &nbsp;
                    </button>
                </div>
                <div className="text-center">
                    <h1>Relatório de IF</h1>
                </div>
                {!loading &&
                    <>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="details">
                                    <strong>Mês/Ano: </strong>{dadosRelatorio?.mesAno ?? 0}<span></span>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="details">
                                    <strong>Contratada: </strong>{dadosRelatorio?.contratada ?? 0} <span></span>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="details">
                                    <strong>Serviços:</strong> <span>Escalonados</span>
                                </div>
                            </div>
                        </div> 

                        <div className="row my-3">
                            <div className="col-md-3">
                                <div className="details">
                                    <strong>Total de BFS: </strong> <span>{dadosRelatorio?.totalBFS ?? 0}</span>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="details">
                                    <strong>Total sem irregularidade: </strong>  <span>{dadosRelatorio?.totalSemIrregularidade ?? 0}</span>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="details">
                                    <strong>Percentual IF:</strong> <span>{(dadosRelatorio?.percentualIF ?? 0).toFixed(2)}%</span>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="details">
                                    <strong>Faixa de Pontos (resultado):</strong> <span>{dadosRelatorio?.resultado ?? 0}</span>
                                </div>
                            </div>
                        </div>

                        <div className="mx-3 w-100">
                            <div className="row my-2">
                                <h2>DETALHAMENTO IF</h2>
                            </div>
                            <div className="row w-100">
                                <table className="table table-bordered table-striped text-center">
                                    <thead>
                                        <tr>
                                            <th className="text-center">Número BFS</th>
                                            <th className="text-center">Irregular?</th>
                                            <th className="text-center">Data/Hora BFS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {dadosRelatorio && dadosRelatorio?.bfsList?.length > 0 ? (
                                            dadosRelatorio.bfsList.map((row, index) => (
                                                <tr key={index}>
                                                    <td className="text-center">{row.numeroBFS || ''}</td>
                                                    <td className="text-center" style={row.irregular === 'Irregular' ? { color: 'red', fontWeight: 'bold' } : {}}>{row.irregular || ''}</td>
                                                    <td className="text-center">
                                                        {!!row.dataHora ? moment(row.dataHora).format('DD/MM/YYYY HH:mm:ss') : ""}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="3" className="text-center">
                                                    Nenhum dado encontrado
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </>
                }
            </div>
        </div>
    );
}
